<template>
	<common-codebox
		toolTipText="Click to copy the Campaign Shortcode."
	>
		<template v-slot:helpText>
			Use the following shortcode or the OptinMonster block to add your inline campaign inside page content.
			<a :href="$urls.docs('how-to-manually-add-an-after-post-or-inline-optin', 'CopyShortcodeBox')" target="_blank" class="omapi-link-arrow-after">Learn More</a>
		</template>
		[optin-monster-inline slug="{{ campaignSlug }}"]
	</common-codebox>
</template>

<script lang="js">
export default  {
	props : {
		/**
		 * Campaign
		 */
		campaignSlug : {
			type     : String,
			required : true,
		},
	},
}
</script>
